import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { CategoryService } from 'app/services/category/category.service';
import { MENU_ITEMS } from './pages-menu';

@Component({
  selector: 'ultra-pages',
  styleUrls: ['pages.component.scss'],
  template: `
    <ultra-one-column-layout>
      <nb-menu [items]="menu"></nb-menu>
      <router-outlet></router-outlet>
    </ultra-one-column-layout>
  `,
})
export class PagesComponent implements OnInit {

  constructor(
    private _categoryService: CategoryService,
    private menuService: NbMenuService,
    private router: Router
  ) {}

  ngOnInit() {
    const array = MENU_ITEMS;

    this._categoryService.buildedMenu.subscribe((data) => {
      this.menu.find((data) => data.title == 'Categorias').children = data;
    })

      this.menuService.onSubmenuToggle().subscribe((event) => {
        if (event.item.queryParams) {
          this.router.navigate([`pages/${event.item.link}`], {
              queryParams: { category: event.item.queryParams.category,
            },
          });
        }
      });
  }

  menu = MENU_ITEMS;
}
